import { Component, forwardRef } from '@angular/core';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

const COUNTER_CONTROL_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TimeCounterComponent),
  multi: true
};

@Component({
  selector: 'time-counter',
  providers: [COUNTER_CONTROL_ACCESSOR],
  styleUrls: ['time-counter.component.scss'],
  templateUrl: 'time-counter.component.html'
})
export class TimeCounterComponent implements ControlValueAccessor {
  hours = 0;
  minutes = 0;
  duration = 0;
  private onChange = (value: any) => {};
  private onTouched = () => {};

  registerOnChange(onChange: (_: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  writeValue(duration: number) {
    let hour, minute;
    minute = Math.floor(duration / (60 * 1000));
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    hour = hour % 24;

    this.minutes = minute;
    this.hours = hour;
  }

  changeDuration(hours, minutes) {
    const sign = [hours, minutes].find(item => item < 0) ? '-' : '+';
    this.duration = ![hours, minutes].includes(null) ? Number(sign + ((hours * 60 + minutes) * 60 * 1000)) : null;
    this.onChange(this.duration);
    this.onTouched();
  }
}
